/* eslint-disable import-helpers/order-imports */
import React from 'react';

import RichText from '@elements/RichText';

import './style.css';

type GlobalRichTextProps = {
  item: {
    body?: {
      raw: string;
    };
  };
};

const GlobalRichText = (props: GlobalRichTextProps): JSX.Element => {
  return (
    <div className='global-rich-text'>
      <RichText bodyRichText={props.item.body} />
    </div>
  );
};

export default GlobalRichText;
